// Version: 2.15
// v2.15: Buttons use the shared button system (CV-49): 8px corners, standard variants and sizes, one selected look; no inline radius, padding or font size.
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from './auth';
import './Login.css';

export default function Login() {
  const { login, startMicrosoftLogin } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername]   = useState('');
  const [password, setPassword]   = useState('');
  const [error, setError]         = useState('');
  const [loading, setLoading]     = useState(false);
  const [msLoading, setMsLoading] = useState(false);
  const [productName, setProductName] = useState('');
  const [tagline, setTagline]     = useState('Cyber Security · STG Limited');

  useEffect(() => {
    fetch('/api/health')
      .then(r => r.json())
      .then(d => {
        if (d.product) {
          setProductName(d.product);
          document.title = `STG ${d.product}`;
        }
        if (d.tagline) setTagline(d.tagline);
      })
      .catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const data = await login(username.trim().toLowerCase(), password);
      if (data.mfa_required) {
        navigate('/mfa', {
          state: {
            pre_token:  data.pre_token,
            username:   data.username,
            email_hint: data.username.slice(0, 3) + '***'
          }
        });
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleMicrosoftLogin = async () => {
    setError(''); setMsLoading(true);
    try {
      await startMicrosoftLogin();
      // Browser navigates away to Microsoft here — no further state update needed.
    } catch (err) {
      setError(err.message);
      setMsLoading(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <span className="login-logo-stg">STG</span>
            <span className="login-logo-sep" />
            <span className="login-logo-sub">{productName || 'Portal'}</span>
          </div>
          <div className="login-tagline">{tagline}</div>
        </div>
        <div className="login-body">
          <form onSubmit={handleSubmit} className="login-form">
            <div className="login-field">
              <label>Email Address</label>
              <input
                type="email"
                autoComplete="email"
                value={username}
                onChange={e => setUsername(e.target.value)}
                placeholder="your@email.com"
                required
              />
            </div>
            <div className="login-field">
              <label>Password</label>
              <input
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            {error && <div className="error-msg">{error}</div>}
            <button className="btn btn-primary btn-lg login-btn" type="submit" disabled={loading}>
              {loading ? <span className="spinner" /> : 'Sign in'}
            </button>
          </form>
          <div style={{display:'flex',alignItems:'center',gap:12,margin:'18px 0'}}>
            <div style={{flex:1,height:1,background:'var(--border)'}} />
            <span style={{fontSize:11,color:'var(--text-muted)'}}>or</span>
            <div style={{flex:1,height:1,background:'var(--border)'}} />
          </div>
          <button className="btn btn-secondary btn-lg btn-block login-btn"
            type="button"
           
           
            onClick={handleMicrosoftLogin}
            disabled={msLoading}
          >
            {msLoading ? <span className="spinner" /> : (
              <>
                <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
                  <rect x="1" y="1" width="6.5" height="6.5" fill="#f25022" />
                  <rect x="8.5" y="1" width="6.5" height="6.5" fill="#7fba00" />
                  <rect x="1" y="8.5" width="6.5" height="6.5" fill="#00a4ef" />
                  <rect x="8.5" y="8.5" width="6.5" height="6.5" fill="#ffb900" />
                </svg>
                Sign in with Microsoft
              </>
            )}
          </button>
          <div className="login-footer" style={{marginTop:16}}>
            <div>Authorised access only</div>
            <div style={{marginTop:8}}>
              <Link to="/register" style={{color:'var(--accent)',fontSize:12,fontWeight:600}}>Request access →</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}